import { Link } from "react-router-dom";
import { Performance } from "@/data/performances";
import { ArrowUpRight } from "lucide-react";
import standUpImg from "@/assets/attractions/stand-up-comedy.jpg";
import kabaretImg from "@/assets/attractions/kabaret.jpg";
import mimowieImg from "@/assets/attractions/mimowie.jpg";
import poetrySlamImg from "@/assets/attractions/poetry-slam.jpg";
import teatrImprowizacjiImg from "@/assets/attractions/teatr-improwizacji.jpg";
import muzykaNaZywoImg from "@/assets/attractions/muzyka-na-zywo.jpg";
import djWodzirejImg from "@/assets/attractions/dj-i-wodzirej.jpg";
import operoweImg from "@/assets/attractions/wystepy-operowe.jpg";
import jazzoweImg from "@/assets/attractions/wystepy-jazzowe.jpg";
import orkiestroweImg from "@/assets/attractions/wystepy-orkiestrowe.jpg";
import beatboxImg from "@/assets/attractions/wystepy-beatboxerow.jpg";
import gitaroweImg from "@/assets/attractions/wystepy-gitarowe.jpg";
import saksofonuImg from "@/assets/attractions/wystepy-saksofonu.jpg";
import perkusyjneImg from "@/assets/attractions/wystepy-perkusyjne.jpg";
import trabkiImg from "@/assets/attractions/wystepy-trabki.jpg";
import wokalneImg from "@/assets/attractions/wystepy-wokalne.jpg";
import choralneImg from "@/assets/attractions/wystepy-choralne.jpg";
import akordeonImg from "@/assets/attractions/wystepy-akordeonowe.jpg";
import skrzypcImg from "@/assets/attractions/wystepy-skrzypcowe.jpg";
import harfaImg from "@/assets/attractions/wystepy-harfowe.jpg";
import fletImg from "@/assets/attractions/wystepy-fletowe.jpg";
import puzonImg from "@/assets/attractions/wystepy-puzonu.jpg";
import wiolonczelaImg from "@/assets/attractions/wystepy-wiolonczele.jpg";
import ukuleleImg from "@/assets/attractions/wystepy-ukulele.jpg";
import mandolinaImg from "@/assets/attractions/wystepy-mandoliny.jpg";
import kontrabasImg from "@/assets/attractions/wystepy-kontrabasu.jpg";
import akrobaciImg from "@/assets/attractions/akrobaci.jpg";
import zonglerzyImg from "@/assets/attractions/zonglerzy.jpg";
import folklorImg from "@/assets/attractions/wystepy-folklorystyczne.jpg";
import laseroweImg from "@/assets/attractions/pokazy-laserowe.jpg";
import multimedialneImg from "@/assets/attractions/pokazy-multimedialne.jpg";
import iluminacjiImg from "@/assets/attractions/pokazy-iluminacji.jpg";
import sztukiCyfrowejImg from "@/assets/attractions/pokazy-sztuki-cyfrowej.jpg";
import sztukiSwiatlaImg from "@/assets/attractions/pokazy-sztuki-swiatla.jpg";
import sztukiKinetycznejImg from "@/assets/attractions/pokazy-sztuki-kinetycznej.jpg";
import iluzjonistaImg from "@/assets/attractions/iluzjonista.jpg";
import fireshowImg from "@/assets/attractions/fireshow.jpg";
import bubbleShowImg from "@/assets/attractions/bubble-show.jpg";
import zonglerkiOgniemImg from "@/assets/attractions/pokazy-zonglerki-ogniem.jpg";
import karykaturzystaImg from "@/assets/attractions/karykaturzysta.jpg";
import bodypaintingImg from "@/assets/attractions/pokazy-bodypainting.jpg";
import origamiImg from "@/assets/attractions/pokazy-origami.jpg";
import garncarskieImg from "@/assets/attractions/pokazy-garncarskie.jpg";
import rzezbiarskieImg from "@/assets/attractions/pokazy-rzezbiarskie.jpg";
import sztukiUlicznejImg from "@/assets/attractions/pokazy-sztuki-ulicznej.jpg";
import sztukiPapierowejImg from "@/assets/attractions/pokazy-sztuki-papierowej.jpg";
import teatrCieniImg from "@/assets/attractions/teatr-cieni.jpg";
import sztukiRecyklinguImg from "@/assets/attractions/pokazy-sztuki-recyklingu.jpg";
import barmanskieImg from "@/assets/attractions/pokazy-barmanskie.jpg";
import kulinarneImg from "@/assets/attractions/pokazy-kulinarne.jpg";
import modyImg from "@/assets/attractions/pokazy-mody.jpg";
import warsztatyAiImg from "@/assets/attractions/warsztaty-ai.jpg";
import pokazyRobotowImg from "@/assets/attractions/pokazy-robotow.jpg";
import pokazyDronowImg from "@/assets/attractions/pokazy-dronow.jpg";
import strefaVrImg from "@/assets/attractions/strefa-vr.jpg";
import druk3dImg from "@/assets/attractions/druk-3d-na-zywo.jpg";
import holograficzneImg from "@/assets/attractions/pokazy-holograficzne.jpg";
import aiArtShowImg from "@/assets/attractions/ai-art-show.jpg";
import robotDanceImg from "@/assets/attractions/robot-dance-show.jpg";
import klaunImg from "@/assets/attractions/klaun-dla-dzieci.jpg";
import magikDzieciImg from "@/assets/attractions/magik-dla-dzieci.jpg";
import animatorImg from "@/assets/attractions/animator-dla-dzieci.jpg";
import teatrLalekImg from "@/assets/attractions/teatr-lalek.jpg";
import malowanieTwarzyImg from "@/assets/attractions/malowanie-twarzy.jpg";
import modelowanieBalonowImg from "@/assets/attractions/modelowanie-balonow.jpg";
import bankiDzieciImg from "@/assets/attractions/banki-mydlane-dla-dzieci.jpg";
import maskotkiImg from "@/assets/attractions/maskotki-i-postacie.jpg";
import warsztatyPlastyczneImg from "@/assets/attractions/warsztaty-plastyczne.jpg";
import miniDiskoImg from "@/assets/attractions/mini-disko.jpg";
import bajkowePrzedstawieniaImg from "@/assets/attractions/bajkowe-przedstawienia.jpg";
import dmuchanceImg from "@/assets/attractions/dmuchance-i-place-zabaw.jpg";
import warsztatyCyrkoweImg from "@/assets/attractions/warsztaty-cyrkowe.jpg";
import musicalDzieciImg from "@/assets/attractions/musical-dla-dzieci.jpg";
import warsztatyNaukoweImg from "@/assets/attractions/warsztaty-naukowe.jpg";
import fotobudkaDzieciImg from "@/assets/attractions/fotobudka-dla-dzieci.jpg";
import sambaImg from "@/assets/attractions/samba.jpg";
import salsaImg from "@/assets/attractions/salsa.jpg";
import tangoImg from "@/assets/attractions/tango-argentynskie.jpg";
import breakdanceImg from "@/assets/attractions/breakdance.jpg";
import flamencoImg from "@/assets/attractions/flamenco.jpg";
import baletImg from "@/assets/attractions/balet.jpg";
import pokazyTaneczneImg from "@/assets/attractions/pokazy-taneczne.jpg";
import pokazySwietlneImg from "@/assets/attractions/pokazy-swietlne.jpg";
import pokazyPirotechniczneImg from "@/assets/attractions/pokazy-pirotechniczne.jpg";
import warsztatyArtystyczneImg from "@/assets/attractions/warsztaty-artystyczne.jpg";
import pokazyKaligrafiiImg from "@/assets/attractions/pokazy-kaligrafii.jpg";
import pokazyNaukoweImg from "@/assets/attractions/pokazy-naukowe.jpg";
import pokazyRobotykiImg from "@/assets/attractions/pokazy-robotyki.jpg";
import pokazyEkologiczneImg from "@/assets/attractions/pokazy-ekologiczne.jpg";
import pokazySztuczekKarcianychImg from "@/assets/attractions/pokazy-sztuczek-karcianych.jpg";

interface OfferCardProps {
  performance: Performance;
}

const cardImages: Record<string, string> = {
  "stand-up-comedy": standUpImg,
  "kabaret": kabaretImg,
  "iluzjonista": iluzjonistaImg,
  "teatr-improwizacji": teatrImprowizacjiImg,
  "muzyka-na-zywo": muzykaNaZywoImg,
  "dj-i-wodzirej": djWodzirejImg,
  "pokazy-taneczne": pokazyTaneczneImg,
  "akrobaci": akrobaciImg,
  "pokazy-swietlne": pokazySwietlneImg,
  "mimowie": mimowieImg,
  "bubble-show": bubbleShowImg,
  "fireshow": fireshowImg,
  "karykaturzysta": karykaturzystaImg,
  "pokazy-laserowe": laseroweImg,
  "wystepy-wokalne": wokalneImg,
  "pokazy-barmanskie": barmanskieImg,
  "teatr-cieni": teatrCieniImg,
  "pokazy-naukowe": pokazyNaukoweImg,
  "zonglerzy": zonglerzyImg,
  "pokazy-multimedialne": multimedialneImg,
  "wystepy-operowe": operoweImg,
  "pokazy-mody": modyImg,
  "warsztaty-artystyczne": warsztatyArtystyczneImg,
  "pokazy-kulinarne": kulinarneImg,
  "wystepy-orkiestrowe": orkiestroweImg,
  "poetry-slam": poetrySlamImg,
  "pokazy-robotyki": pokazyRobotykiImg,
  "wystepy-folklorystyczne": folklorImg,
  "pokazy-ekologiczne": pokazyEkologiczneImg,
  "wystepy-beatboxerow": beatboxImg,
  "wystepy-jazzowe": jazzoweImg,
  "pokazy-sztuki-cyfrowej": sztukiCyfrowejImg,
  "wystepy-akordeonowe": akordeonImg,
  "pokazy-iluminacji": iluminacjiImg,
  "wystepy-choralne": choralneImg,
  "pokazy-bodypainting": bodypaintingImg,
  "wystepy-perkusyjne": perkusyjneImg,
  "pokazy-pirotechniczne": pokazyPirotechniczneImg,
  "wystepy-skrzypcowe": skrzypcImg,
  "pokazy-sztuki-ulicznej": sztukiUlicznejImg,
  "wystepy-gitarowe": gitaroweImg,
  "pokazy-origami": origamiImg,
  "wystepy-harfowe": harfaImg,
  "pokazy-garncarskie": garncarskieImg,
  "wystepy-fletowe": fletImg,
  "pokazy-rzezbiarskie": rzezbiarskieImg,
  "wystepy-saksofonu": saksofonuImg,
  "pokazy-kaligrafii": pokazyKaligrafiiImg,
  "wystepy-trabki": trabkiImg,
  "pokazy-sztuczek-karcianych": pokazySztuczekKarcianychImg,
  "wystepy-puzonu": puzonImg,
  "pokazy-zonglerki-ogniem": zonglerkiOgniemImg,
  "wystepy-wiolonczele": wiolonczelaImg,
  "pokazy-sztuki-kinetycznej": sztukiKinetycznejImg,
  "wystepy-kontrabasu": kontrabasImg,
  "pokazy-sztuki-swiatla": sztukiSwiatlaImg,
  "wystepy-ukulele": ukuleleImg,
  "pokazy-sztuki-papierowej": sztukiPapierowejImg,
  "wystepy-mandoliny": mandolinaImg,
  "pokazy-sztuki-recyklingu": sztukiRecyklinguImg,
  "warsztaty-ai": warsztatyAiImg,
  "pokazy-robotow": pokazyRobotowImg,
  "pokazy-dronow": pokazyDronowImg,
  "strefa-vr": strefaVrImg,
  "druk-3d-na-zywo": druk3dImg,
  "pokazy-holograficzne": holograficzneImg,
  "ai-art-show": aiArtShowImg,
  "robot-dance-show": robotDanceImg,
  "klaun-dla-dzieci": klaunImg,
  "magik-dla-dzieci": magikDzieciImg,
  "animator-dla-dzieci": animatorImg,
  "teatr-lalek": teatrLalekImg,
  "malowanie-twarzy": malowanieTwarzyImg,
  "modelowanie-balonow": modelowanieBalonowImg,
  "banki-mydlane-dla-dzieci": bankiDzieciImg,
  "maskotki-i-postacie": maskotkiImg,
  "warsztaty-plastyczne": warsztatyPlastyczneImg,
  "mini-disko": miniDiskoImg,
  "bajkowe-przedstawienia": bajkowePrzedstawieniaImg,
  "dmuchance-i-place-zabaw": dmuchanceImg,
  "warsztaty-cyrkowe": warsztatyCyrkoweImg,
  "musical-dla-dzieci": musicalDzieciImg,
  "warsztaty-naukowe": warsztatyNaukoweImg,
  "fotobudka-dla-dzieci": fotobudkaDzieciImg,
  "samba": sambaImg,
  "salsa": salsaImg,
  "tango-argentynskie": tangoImg,
  "breakdance": breakdanceImg,
  "flamenco": flamencoImg,
  "balet": baletImg,
};

export const OfferCard = ({ performance }: OfferCardProps) => {
  const bgImage = cardImages[performance.slug];

  return (
    <Link to={`/atrakcje/${performance.slug}`} className="block h-full group">
      <div className="relative h-[280px] rounded-2xl overflow-hidden border border-white/10 hover:border-accent/40 transition-all duration-500 group-hover:shadow-xl group-hover:shadow-accent/10">
        {/* Background image */}
        <div
          className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
          style={{ backgroundImage: `url(${bgImage})` }}
        />

        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

        {/* Content */}
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <h3 className="text-lg font-montserrat font-bold text-white mb-1 group-hover:text-accent transition-colors">
            {performance.title}
          </h3>
          <p className="text-white/60 text-sm line-clamp-2">
            {performance.description}
          </p>
        </div>

        {/* Arrow */}
        <div className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:bg-accent">
          <ArrowUpRight className="w-4 h-4 text-white" />
        </div>
      </div>
    </Link>
  );
};
